export const InvoicesAttachedSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 3H5C3.9 3 3 3.9 3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-4-8h-4v2h4v-2zm0 4h-4v2h4v-2zm2-8H9v2h8v-2z"
      fill="currentColor"
    />
  </svg>
);
